function fieldsToNumbers(inputs) {
  const processedInputs = {};
  const keys = Object.keys(inputs);
  for (const key of keys) {
    if (key === 'propertyIntent') {
      processedInputs[key] = inputs[key]
    } else if (!inputs[key]) {
      processedInputs[key] = 0;
    } else if (typeof inputs[key] === 'string') {
      processedInputs[key] = parseFloat(inputs[key])
    } else {
      processedInputs[key] = inputs[key]
    }
  }
  console.log('processedInputs:', processedInputs);
  return processedInputs;
}

export default fieldsToNumbers;
